import { ReactFlowInstance, Node, MarkerType, addEdge, Edge } from "@xyflow/react";
import { Agent } from "../../../../../types/workflow";
import { Tool } from "../../../../../types/entities";



/**
 * Generate random string ID for length param
 * @param length
 */
function createRandomString(length: number): string {
    const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let result = "";
    for (let i: number = 0; i < length; i++) {
        result += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return result;
}

/**
 * Handle node create and edit for submission
 * @param context
 * @param formData
 * @param reactFlowInstance
 * @param setEdges
 */
export function processNodeFormSubmit(context: any,
                                      formData: any,
                                      reactFlowInstance: ReactFlowInstance,
                                      setEdges: any
): void {

    // debugger;
    let tempNode: Node = context.selectedNode;
    tempNode.data = formData;

    let allNodes: Node[] = reactFlowInstance.getNodes();
    let updatedNodes: Node[] = [tempNode];
    for (const node of allNodes) {
        if (node.id !== tempNode.id) {
            updatedNodes.push(node);
        }
    }
    //create node for agent if needed
    if (formData.workflowId === undefined) {
        const rightNow: string = createRandomString(10);
        let tmpEdges: Edge[] = reactFlowInstance.getEdges();
        let updatedEdges: Edge[] = [];
        for (const edge of tmpEdges) {
            updatedEdges.push(edge);
        }

        if (formData.tools.length > 0) {

            for (let v: number = 0; v < formData.tools.length; v++) {
                let toolId: any = formData.tools[v];
                let fullTool: Tool = findTool(context, toolId);
                let toolName = 'Untitled Tool';
                if (fullTool) {
                    toolName = fullTool.name;
                }
                const elementId: string = createRandomString(10);
                // const id = 'node_' + tempNode.id + '_agent_' + rightNow + '_tool_' + elementId + '__graphNode';
                const id: string = 'node_' + tempNode.id + '_tool_' + elementId + '__graphNode';
                const toolNode = {
                    id: id,
                    data: {
                        label: toolName,
                        tool_id: elementId,
                        // agentId: rightNow,
                        workflowId: tempNode.id,
                        toolId: toolId,
                    },
                    position: {
                        x: tempNode.position.x + (tempNode.measured ? tempNode.measured.width + 150 : 300),
                        y: tempNode.position.y - (100 * (formData.tools.length - v)),
                    },
                    type: 'workflowToolNode'
                }
                updatedNodes.push(toolNode);
                // const edgeId = 'node_' + tempNode.id + '_agent_' + rightNow + '_tool_' + elementId + '__graphEdge';
                const edgeId = 'node_' + tempNode.id + '_tool_' + elementId + '__graphEdge';
                const markerEnd: { color: string, type: MarkerType } =  {
                    color: '#FF0072',
                    type: MarkerType.Arrow,
                };
                const markerStyle: { stroke: string, strokeWidth: number } = {
                    stroke: '#FF0072',
                    strokeWidth: 2,
                };
                const edge: Edge = {
                    id: edgeId,
                    source: tempNode.id,
                    target: id,
                    reconnectable: false,
                    animated: true,
                    selectable: false,
                    markerEnd: markerEnd,
                    style: markerStyle,
                    type: 'step',
                };
                updatedEdges.push(edge);
            }
        }
        formData.workflowId = tempNode.id;
        formData.agent_id = rightNow;
        // reactFlowInstance.setNodes(updatedNodes);
        context.updateLayoutNodes(updatedNodes);

        // reactFlowInstance.setEdges(updatedEdges);
        context.updateLayoutEdges(tmpEdges)


    } else {
        // edit tool nodes and respective edges if needed
        let allEdges: Edge[] = reactFlowInstance.getEdges();
        let allNodes: Node[] = reactFlowInstance.getNodes();
        let nodeId: string = tempNode.id;

        let updatedNodes: Node[] = [tempNode];
        for (const node of allNodes) {
            if (node.type === 'workflowToolNode' &&
                node.data.workflowId === tempNode.id
            ) {
                continue;
            }
            if (node.id === nodeId ) {
                continue;
            }

            updatedNodes.push(node);
        }

        let updatedEdges: Edge[] = [];
        for (const edge of allEdges) {
            if (!edge.id.includes(nodeId + '_tool_')) {
                updatedEdges.push(edge);
            }
        }

        if (formData.tools.length > 0) {

            for (let v: number = 0; v < formData.tools.length; v++) {
                let toolId: any = formData.tools[v];
                let fullTool: Tool = findTool(context, toolId);
                let toolName = 'Untitled Tool';
                if (fullTool) {
                    toolName = fullTool.name;
                }
                const elementId: string = createRandomString(10);
                // const id = 'node_' + tempNode.id + '_agent_' + rightNow + '_tool_' + elementId + '__graphNode';
                const id: string = 'node_' + tempNode.id + '_tool_' + elementId + '__graphNode';
                const toolNode = {
                    id: id,
                    data: {
                        label: toolName,
                        tool_id: elementId,
                        // agentId: rightNow,
                        workflowId: tempNode.id,
                        toolId: toolId,
                    },
                    position: {
                        x: tempNode.position.x + (tempNode.measured ? tempNode.measured.width + 150 : 300),
                        y: tempNode.position.y - (100 * (formData.tools.length - v)),
                    },
                    type: 'workflowToolNode'
                }
                updatedNodes.push(toolNode);
                // const edgeId = 'node_' + tempNode.id + '_agent_' + rightNow + '_tool_' + elementId + '__graphEdge';
                const edgeId: string = 'node_' + tempNode.id + '_tool_' + elementId + '__graphEdge';
                const markerEnd: { color: string, type: MarkerType } =  {
                    color: '#FF0072',
                    type: MarkerType.Arrow,
                };
                const markerStyle: { stroke: string, strokeWidth: number } = {
                   stroke: '#FF0072',
                   strokeWidth: 2,
                };
                const edge: Edge = {
                    id: edgeId,
                    source: tempNode.id,
                    target: id,
                    reconnectable: false,
                    animated: true,
                    selectable: false,
                    markerEnd: markerEnd,
                    style: markerStyle,
                    type: 'step'
                };
                updatedEdges.push(edge);

            }
        }
        // tempNode.data = formData

        // reactFlowInstance.setNodes(updatedNodes);
        context.updateLayoutNodes(updatedNodes);
        // reactFlowInstance.setEdges(updatedEdges);
        context.updateLayoutEdges(updatedEdges);

    }


}


function findTool(context: any, toFindToolId: string): Tool|undefined {
    let fullTool: Tool = undefined;
    for (let i: number = 0; i < context.tools.length; i++) {
        let tool: Tool = context.tools[i];
        if (tool.operatorToolId.toString() === toFindToolId) {
            fullTool = tool;
            break;
        }
    }
    return fullTool;
}


/**
 * Delete workflow node and all child nodes and edges
 * @param context
 * @param reactFlowInstance
 */
export function processNodeDelete(context: any, reactFlowInstance: ReactFlowInstance): void {
    let nodes: Node[] = context.nodes;
    let newNodes: Node[] = [];
    let deleteNodes: Node[] = [];
    for (const node of nodes) {
        if (!node.id.includes(context.selectedNode.id)) {
            newNodes.push(node);
        } else {
            deleteNodes.push(node);
            // reactFlowInstance.deleteElements(node.id);
        }
    }

    let edges = context.edges;
    let removeEdges = [];
    let newEdges = [];
    for (const edge of edges) {
        if (edge.id.includes(context.selectedNode.id)) {
            removeEdges.push(edge);
            // reactFlowInstance.deleteElements(edge.id);
        } else {
            newEdges.push(edge);
        }
    }
    // reactFlowInstance.setEdges(newEdges);
    // reactFlowInstance.setNodes(newNodes);

    context.updateLayoutNodes(newNodes);
    context.updateLayoutEdges(newEdges);
}


export const nodeDescription: string = "This node is used to process data via an LLM. \n" +
    "Each agent will complete the assigned task and set the results to a data slot. \n" +
    "A supervisor agent will delegate tasks to other agent(s) until completion.\n" +
    "You can create your own prompts or load in the system default.\n" +
    "Different LLM's are better at different tasks and can be set per agent.\n" +
    "Each agent can be set to return different data types. A Data Model type is created from the structure JSON.\n" +
    "Tools are optional for each agent. They can be used to enhance the abilities of the Agent.\n" +
    "This node has some variables you can use in prompts:\n" +
    "- {{user_input}} - The most recently entered value by a user.\n" +
    "- {{last_message}} - The last message generated by a previous Agent or LLM response\n" +
    "- {{default}} - The value in the default Data Slot.\n" +
    "- {{data_XXX}} - The value in the Data Slot with the given name. The XXX is replaceable with the words one through ten.\n" +
    "\n" +
    "If the agent node is connected to a supervisor agent, some of the fields are disabled";

